import { Trans } from "@lingui/macro";
import { UiBox } from "@smp/ui";
import { FC } from "react";

import { IProductDescriptionProps } from "../../product_description";

export const CompositionPostsPackage: FC<{
  product: Extract<
    IProductDescriptionProps["product"],
    { type: "posts-package" }
  >;
}> = ({ product }) => (
  <UiBox display="flex" flexDirection="row">
    <UiBox flexGrow={1} pl={2}>
      <Trans>Quantity</Trans>
    </UiBox>
    <UiBox flexGrow={1} textAlign="right">
      {product.amount}
    </UiBox>
  </UiBox>
);
